module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', [_vm._v("101 Things to do with a Cake Mix")]), _vm._v(" "), _c('div', {
    staticClass: "toc"
  }, [_c('p', [_c('b', [_vm._v("Table of Contents")])]), _vm._v(" "), _c('dl', [_c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Helpful Hints")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Brownies and Bars")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("White-Chocolate Fudge Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Squares")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e129",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter-Chocolate Chip Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e150",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cheesecake Bars (Grandma Dircks’\n                                    Specialty)")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Squares")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e195",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e214",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Chip Squares")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e229",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Lemon Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e254",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Squares")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e275",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e303",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Chocolate Chip Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e322",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gooey Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heavenly Brownies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Cinnamon Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e408",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterscotch Chip Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reese’s Pieces Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e440",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Pie Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e478",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese Bars")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#d0e510",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German Chocolate Bars")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e544",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Reese’s Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e561",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chewy Lemon Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e578",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sweet Delights")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e597",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Chip Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e618",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Touch o’ Honey")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e637",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peanut Butter-Kiss Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e656",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Snicker Doodles")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e679",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterfinger Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e698",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick and Easy Peanut Butter Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e719",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Butterscotch-Chip Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e736",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy M&M Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#d0e755",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choco Sandwich Cookies")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruity Cakes")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e780",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Pie-Filling Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e810",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon-Lime Refrigerator Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e834",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Pie-Filling Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e868",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Split Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e899",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Piña Colada Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e920",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry-Chocolate Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e937",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Applesauce Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e960",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fruit Cocktail Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple-Orange Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Mandarin Orange Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Punchbowl Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Tropical Getaway Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1130",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peach Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1155",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple-Spice Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1180",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hawaiian Pineapple Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1201",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pineapple-Cherry Dump Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1220",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Apple Streusel")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1252",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Coffee Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1288",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Blueberry Dump Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#d0e1305",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valentine Love Cake")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Fancy Cakes")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1332",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Dump Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1347",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry-Banana Gelatin Poke Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1366",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Strawberry Decadence")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1383",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Yogurt Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1407",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cookies-and-Cream Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1437",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Heath Bar Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1456",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterfinger Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1475",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pudding Poke Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1587",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cherry Chunk Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1608",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Confetti Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1644",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Lover’s Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1665",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Cheesecake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1716",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Orange-Pumpkin Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1756",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Butterfinger Crumb Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1773",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Swiss-Chocolate Dump Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1792",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate-Crumb Pudding Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1815",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Upside-Down German Chocolate Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1842",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemonade Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1861",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Choconut Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1893",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate Caramel Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1908",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Marbled Love Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1927",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Caramel-Pecan Chocolate Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#d0e1950",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Gelatin Poke Cake")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bundt Cakes")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e1971",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lemon Poppy-Seed Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Death-by-Chocolate Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana Bundt Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pistachio Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pistachio Pound Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Incredible Bundt Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2136",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cream Cheese-Lemon Pound Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch06#d0e2161",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Luscious Lemon Cake")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Muffins and Bread")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2199",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oatmeal-Raisin Muffins")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2224",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Banana Bread")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2251",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Banana-Nut Muffins")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2272",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chocolate–Chocolate Chip Muffins")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch07#d0e2297",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick and Easy Cornbread")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Children’s Delights")])])]), _vm._v(" "), _c('dd', [_c('dl', [_c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2314",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Quick and Easy Apple Crisp")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2337",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Snicker’s Surprise Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2356",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Delicious Dirt")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2377",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Ice Cream-Cone Cupcakes")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2404",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Easy Ice Cream Sandwiches")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2425",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Valentine Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2446",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("American Flag Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2469",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Jack-O-Lantern Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2486",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Black Cat Cookies")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2507",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin-Patch Halloween Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Halloween Spider Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2572",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Pumpkin Delight")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2621",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Peppermint Cake")])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "bridgehead"
  }, [_c('span', {
    attrs: {
      "href": "#/ch08#d0e2651",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Christmas-Rainbow Poke Cake")])])])])]), _vm._v(" "), _c('dt', [_c('span', {
    staticClass: "chapter"
  }, [_c('span', {
    attrs: {
      "href": "#/ch09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Metric Conversion Chart")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2835850b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bk01-toc.vue
// module id = 63
// module chunks = 0